import { render, staticRenderFns } from "./ChipDistributionLayout.vue?vue&type=template&id=f54bda74&"
import script from "./ChipDistributionLayout.vue?vue&type=script&lang=js&"
export * from "./ChipDistributionLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports